import { createBox } from '@mui/system';
import boxTheme from './Box.theme.js';

/**
 * https://mui.com/api/Box/
 * Unlike other MUI components, Box must be extended using `createBox`.
 * See https://mui.com/system/react-box/#create-your-own-box-component.
 * Our current version of Material, 5.8.3, returns a `Box` of the wrong type so we have to assert the type.
 * The MUI maintainers fixed this in a subsequent version but said we can use `as typeof MuiBox`.
 * See: https://github.com/mui/material-ui/issues/35506
 */
const Box = createBox({ defaultTheme: boxTheme });

export { Box as default };
//# sourceMappingURL=Box.js.map
